import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import {
    IGetDestinationActionParams
} from "../../../Orchestrator/Types/Interface/ICmsDestination";

class DestinationsDicoverClickAction extends BaseAction<void, IGetDestinationActionParams> {
    override async run(): Promise<void> {
        const { slug } = this.params!;
        updateRecoilState("destinationDetailAtom", null);
        _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: `/destinations/${slug}`,
        })
    }
}

export const destinationsDicoverClickAction = new DestinationsDicoverClickAction();
